import { render, staticRenderFns } from "./CrudGeneralLedgerAccounts.vue?vue&type=template&id=49e2b24f&scoped=true"
import script from "./CrudGeneralLedgerAccounts.vue?vue&type=script&lang=js"
export * from "./CrudGeneralLedgerAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2b24f",
  null
  
)

export default component.exports